/**
 * Employee Web — `/me/expenses` section layout route.
 *
 * Phase 19 Plan 01. Parent layout for `/me/expenses` (landing),
 * `/me/expenses/new` (form), and `/me/expenses/$id` (detail). It must render an
 * <Outlet/> so those child routes display — the landing lives in the index
 * route (`_auth.me.expenses.index.tsx`). Rendering the landing directly here
 * (no Outlet) made `/me/expenses/new` show the landing instead of the form
 * (same class of bug as `/me/loans/new`).
 * Permission gate: `expense:read:self`.
 */
import type { JSX } from "react";
import { Outlet, createFileRoute } from "@tanstack/react-router";
import { requirePermission } from "@linkhr/auth";

export const Route = createFileRoute("/_auth/me/expenses")({
  staticData: { breadcrumb: { labelKey: "expenses:me.expenses.page.title" } },
  beforeLoad: requirePermission({
    anyOf: ["expense:read:self"],
    defaultRoute: "/me/overview",
  }),
  component: MeExpensesRoute,
});

function MeExpensesRoute(): JSX.Element {
  return <Outlet />;
}
